module.exports = {
  ENV: 'prod',
  APP_NAME: 'cal',
  END_POINT: 'https://ssm.services.apihf.com',
  API_KEY: 'MdSonRVC2w87AXdNLKKczGXFdn8yr7n4N2gBQuEh',
  BRAND_KEY: '817fe87f-cda3-4250-9dbf-e1572d504a3b',
  LANG: 'fr-FR'
}